var map = {
	"./billing.png": "c875",
	"./bookeeping.png": "b85c",
	"./catalogue.png": "b25e",
	"./checkbook.png": "d568",
	"./conductor.png": "a0cb",
	"./documents.png": "dad4",
	"./monitoring.webp": "7df1",
	"./operations.png": "2244",
	"./rrhh.png": "6e76",
	"./settings.png": "d520a",
	"./store.png": "ad30",
	"./treasury.png": "b9a2",
	"./users.png": "10bd",
	"./workshop.png": "d01d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c614";